import * as yup from 'yup';

export const activityFeedSchema = yup.object({
  content: yup.string().max(10000),
});

export const postReplySchema = yup.object({
  content: yup.string().max(1000),
});
